<button (mouseleave)="hover=false" (mouseover)="hover=true"
    [ngStyle]="{'background-color': hover ? '#fff' : color, 
                'color': hover ? color : '#fff',
                'border-color' : hover ? color : 'transparent'}"
    class="joyride-button" (click)="onClick()">
    <ng-content></ng-content>
</button>